// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-card[data-v-6eadbf9a]{border:1px solid #ebeef5;border-radius:25px;padding:1em}", ""]);
// Exports
module.exports = exports;
